import { useEngine } from '@/contexts/DashboardContextProvider/DashboardContextProvider'
import { usePathname } from 'next/navigation'
import { removeCookie } from '@/utils/utils'
import axios from '@/utils/axiosInterceptor'
import posthog from 'posthog-js'

import Icon from '../Icon/Icon'
import Button from '../Button/Button'

import WhiteLogo from '@/images/white-logo.svg'
import Logo from '@/images/logo.svg'

import styles from './Sidebar.module.scss'
import classNames from 'classnames/bind'
const classes = classNames.bind(styles)

/**
 * Create the category sidebar.
 *
 * @param {Object} categories The category object which contains the status of the different categories.
 * @param {String} selectedCategory The current selected category.
 * @returns The category sidebar JSX element
 */
export default function Sidebar() {
    const {
        state: { user, sidebarOpen },
        dispatch,
    } = useEngine()

    // Cycle through the keys from the response.
    return (
        <>
            <div className={classes('mobile-bar')}>
                <Logo className={classes('logo')} />
                <Button
                    type="white-gray"
                    icon="menu"
                    onClick={() => {
                        dispatch({
                            type: 'TOGGLE_SIDEBAR_STATE',
                        })
                    }}
                />
            </div>
            <div
                className={classes('overlay', { open: sidebarOpen })}
                onClick={() => {
                    dispatch({
                        type: 'TOGGLE_SIDEBAR_STATE',
                        payload: false,
                    })
                }}
            ></div>
            <div className={classes('sidebar-wrapper', { open: sidebarOpen })}>
                <div className={classes('logo-wrapper')}>
                    <WhiteLogo />
                </div>
                <div id="category-sidebar" className={classes('wrapper')}>
                    <div className={classes('title')}>Menu</div>
                    <CategoryItem name="Home" icon="home" href={'/'} />
                    <CategoryItem name="Personal Tax" icon="user" href={'/self-assessment'} />
                    <CategoryItem name="Partnership" icon="users" href={'/partnership'} />
                    <CategoryItem name="Limited Company" icon="corporate" href={'/company'} />
                    <CategoryItem name="Making Tax Digital" icon="cpu" href={'/mtd-itsa'} />
                    <CategoryItem name="Company Incorporation" icon="package" href={'/incorporation'} />
                    <CategoryItem name="Our Partners" icon="rocket" href={'/recommendations'} />
                    <CategoryItem name="Referrals" icon="refresh-cw" href={'/referrals'} />
                    <CategoryItem name="Billing" icon="home" href={'/billing'} />
                    <CategoryItem name="Settings" icon="settings" href={'/settings'} />
                </div>
                <Footer {...user} />
            </div>
        </>
    )
}

const CategoryItem = ({ name, icon, href }) => {
    return (
        <a
            className={classes('item', {
                selected: usePathname() === href,
            })}
            href={href}
        >
            <div className={classes('icon-wrapper')}>
                <Icon name={icon} category="sidebar" className={classes('icon')} />
            </div>
            <span className={classes('category-name')}>{name}</span>
        </a>
    )
}

const Footer = ({ firstName, lastName, email }) => {
    return (
        <div className={classes('user-container')}>
            <div className={classes('user-details')}>
                <span className={classes('user-name')}>
                    {firstName} {lastName}
                </span>
                <span className={classes('user-email')}>{email}</span>
            </div>
            <a
                className={classes('logout')}
                onClick={async () => {
                    try {
                        await axios.post(`/assessment/api/auth/logout`)

                        removeCookie('AID')
                        posthog.reset()
                        window.location.href = '/login'
                    } catch (e) {
                        alert('Logout failed.')
                    }
                }}
            >
                <Icon name="logout" alt="logout-icon" />
            </a>
        </div>
    )
}
